<template>
	<el-dialog title="" :visible.sync="visible" width="480px" :close-on-click-modal="false" @close="onClose"
		:show-close="false" custom-class="red-packet-dialog">
		<div :class="['red-packet-modal', opened ? 'is-opened' : '']">
			<button class="close-btn" @click="onClose">✕</button>

			<!-- 未领取状态 -->
			<div v-if="!opened" class="packet-unopened">
				<div class="sender-info">
					<span class="sender-name">{{ packet ? packet.senderName + '的红包' : '红包' }}</span>
				</div>

				<!-- 红包图标 -->
				<div class="packet-icon">
					<div class="envelope-wrapper">
						<div class="envelope-icon">
							<div class="envelope-body"></div>
							<div class="envelope-flap"></div>
							<div class="coin">
								<span class="coin-symbol">¥</span>
							</div>
						</div>
					</div>
				</div>

				<div class="greeting-text">{{ packet ? packet.message : '恭喜发财，大吉大利' }}</div>

				<!-- 普通红包显示金额预览 -->
				<div v-if="isNormalPacket" class="packet-amount-preview">
					<span class="preview-label">普通红包</span>
					<div class="preview-amount">
						<span class="currency">￥</span>
						<span class="amount">{{ normalPacketAmount }}</span>
					</div>
				</div>

				<!-- 拼手气红包 -->
				<div v-else class="packet-type-preview">
					<span class="type-label">拼手气红包</span>
					<span class="type-desc">等你来拆~</span>
				</div>

				<el-button type="danger" size="large" class="receive-btn" :loading="isOpening" :disabled="isOpening"
					@click="onReceive">
					{{ isOpening ? '领取中...' : '领取红包' }}
				</el-button>
			</div>

			<!-- 已领取状态 -->
			<div v-else class="packet-opened">
				<div class="amount-display">
					<span class="currency">￥</span>
					<span class="amount">{{ displayAmount }}</span>
				</div>
				<div class="success-text">领取成功</div>
			</div>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: "RedPacketOpen",
	data() {
		return {
			visible: false,
			packet: null,
			opened: false,
			isOpening: false,
			displayAmount: ''
		}
	},
	computed: {
		isNormalPacket() {
			return this.packet && this.packet.packetType === 1;
		},
		normalPacketAmount() {
			if (!this.packet || !this.packet.totalAmount) {
				return '0.00';
			}
			return this.packet.totalAmount.toFixed(2);
		}
	},
	methods: {
		open(packetInfo) {
			this.packet = packetInfo;
			this.visible = true;
			this.reset();
		},
		onClose() {
			this.visible = false;
			// 延迟重置状态，等待关闭动画完成
			setTimeout(() => {
				this.reset();
			}, 300);
		},
		reset() {
			this.opened = false;
			this.isOpening = false;
			this.displayAmount = '';
		},
		onReceive() {
			if (this.isOpening || this.opened) {
				return;
			}

			this.isOpening = true;

			// 触发父组件的领取逻辑
			this.$emit('open', this.packet, this.completeReceiving);
		},
		completeReceiving(amount) {
			if (!amount) {
				// 失败，返回初始状态
				this.isOpening = false;
				return;
			}

			// 格式化金额
			this.displayAmount = parseFloat(amount).toFixed(2);

			// 延迟切换到成功状态，增加动画效果
			setTimeout(() => {
				this.opened = true;
				this.isOpening = false;

				// 3秒后自动关闭
				setTimeout(() => {
					this.onClose();
				}, 3000);
			}, 300);
		}
	}
}
</script>

<style lang="scss" scoped>
::v-deep .red-packet-dialog {
	border-radius: 16px;
	overflow: hidden;

	.el-dialog__header {
		display: none;
	}

	.el-dialog__body {
		padding: 0;
	}
}

.red-packet-modal {
	position: relative;
	padding: 40px 30px;
	background: linear-gradient(135deg, #FFA73D 0%, #FFB84D 100%);
	min-height: 500px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	.close-btn {
		position: absolute;
		top: 15px;
		right: 15px;
		width: 32px;
		height: 32px;
		border: none;
		background: rgba(0, 0, 0, 0.1);
		color: white;
		border-radius: 50%;
		font-size: 18px;
		cursor: pointer;
		transition: all 0.2s ease;
		display: flex;
		align-items: center;
		justify-content: center;

		&:hover {
			background: rgba(0, 0, 0, 0.2);
			transform: rotate(90deg);
		}
	}

	// 未领取状态
	.packet-unopened {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 20px;

		.sender-info {
			.sender-name {
				font-size: 18px;
				color: white;
				font-weight: 500;
			}
		}

		.packet-icon {
			margin: 20px 0;

			.envelope-wrapper {
				position: relative;
			}

			.envelope-icon {
				position: relative;
				width: 120px;
				height: 100px;
			}

			.envelope-body {
				position: absolute;
				bottom: 0;
				left: 0;
				width: 120px;
				height: 80px;
				background: linear-gradient(135deg, #E63946 0%, #F25C66 50%, #E63946 100%);
				border-radius: 8px;
				box-shadow: 0 4px 12px rgba(230, 57, 70, 0.4);
			}

			.envelope-flap {
				position: absolute;
				top: 0;
				left: 0;
				width: 0;
				height: 0;
				border-left: 60px solid transparent;
				border-right: 60px solid transparent;
				border-top: 50px solid #C62D39;
				filter: drop-shadow(0 2px 6px rgba(198, 45, 57, 0.3));
			}

			.coin {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				width: 56px;
				height: 56px;
				background: linear-gradient(135deg, #FFD56F 0%, #FFBF3F 100%);
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				box-shadow: 0 4px 12px rgba(255, 191, 63, 0.5),
					inset 0 2px 4px rgba(255, 255, 255, 0.5);
				z-index: 2;
			}

			.coin-symbol {
				font-size: 32px;
				font-weight: 700;
				color: #E63946;
				text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
			}
		}

		.greeting-text {
			font-size: 20px;
			color: white;
			text-align: center;
			max-width: 100%;
			overflow: hidden;
			text-overflow: ellipsis;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
		}

		.packet-amount-preview {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 10px;
			margin-top: 10px;

			.preview-label {
				font-size: 14px;
				color: rgba(255, 255, 255, 0.9);
				background: rgba(0, 0, 0, 0.1);
				padding: 4px 12px;
				border-radius: 12px;
			}

			.preview-amount {
				display: flex;
				align-items: baseline;

				.currency {
					font-size: 20px;
					color: white;
					margin-right: 4px;
				}

				.amount {
					font-size: 32px;
					color: white;
					font-weight: 600;
				}
			}
		}

		.packet-type-preview {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: 8px;
			margin-top: 10px;

			.type-label {
				font-size: 14px;
				color: rgba(255, 255, 255, 0.9);
				background: rgba(0, 0, 0, 0.1);
				padding: 4px 12px;
				border-radius: 12px;
			}

			.type-desc {
				font-size: 16px;
				color: rgba(255, 255, 255, 0.8);
			}
		}

		.receive-btn {
			margin-top: 30px;
			width: 200px;
			height: 50px;
			font-size: 18px;
			font-weight: 600;
			border-radius: 25px;
			background: linear-gradient(135deg, #FFD56F 0%, #FFBF3F 100%);
			border: none;
			color: #E63946;
			box-shadow: 0 4px 12px rgba(255, 191, 63, 0.4);
			transition: all 0.2s ease;

			&:hover {
				transform: translateY(-2px);
				box-shadow: 0 6px 16px rgba(255, 191, 63, 0.5);
			}

			&:active {
				transform: translateY(0);
			}
		}
	}

	// 已领取状态
	.packet-opened {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 30px;

		.amount-display {
			display: flex;
			align-items: baseline;
			animation: amountPop 0.6s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;

			.currency {
				font-size: 32px;
				color: white;
				margin-right: 8px;
				font-weight: 600;
			}

			.amount {
				font-size: 64px;
				color: white;
				font-weight: 700;
			}
		}

		.success-text {
			font-size: 24px;
			color: white;
			font-weight: 500;
			animation: fadeIn 0.5s ease 0.3s forwards;
			opacity: 0;
		}
	}

	// 切换状态时的背景渐变
	&.is-opened {
		background: linear-gradient(135deg, #10B981 0%, #059669 100%);
	}
}

@keyframes amountPop {
	0% {
		opacity: 0;
		transform: scale(0.5);
	}

	50% {
		transform: scale(1.1);
	}

	100% {
		opacity: 1;
		transform: scale(1);
	}
}

@keyframes fadeIn {
	0% {
		opacity: 0;
		transform: translateY(20px);
	}

	100% {
		opacity: 1;
		transform: translateY(0);
	}
}
</style>

